var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg011EarProtection = function Svg011EarProtection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M437 211c0-99.3-81.7-180-181-180S75 111.7 75 211c-41.353 0-75 33.647-75 75v165h60V331H30v-45c0-24.814 20.186-45 45-45h30c16.5 0 30-13.5 30-30 0-66.301 54.699-120 121-120s121 53.699 121 120c0 16.5 13.5 30 30 30h30c24.814 0 45 20.186 45 45v45h-30v120h60V286c0-41.353-33.647-75-75-75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90 301h60v180H90zM362 301h60v180h-60z"
  })));
};
export default Svg011EarProtection;